import { MathCosIcon } from './MathCosIcon';

/**
 * author: Michael Irigoyen
 * id 6C00C0F3-F537-4591-B7BA-752A1CCD7E38
 * name math-cos
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-cos.svg
 * tags
 * - Math 
 */
export const MathsCosIcon = MathCosIcon;
export default MathsCosIcon